import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";
import IndustriesSection from '../../../components/IndustriesSection';

import { FaLaptopCode, FaMobileAlt, FaBuilding, FaCloud, FaPlug, FaDatabase, FaCogs, FaSyncAlt } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";

const serviceCards = [
  {
    icon: <FaLaptopCode size={80} color="var(--brand-primary)" />,
    title: "Custom Web Application Development",
    description: "Tailored web solutions to meet your business needs, from interactive portals to robust e-commerce platforms. We ensure seamless user experiences, high performance, and scalable architectures for your business growth.",
  },
  {
    icon: <FaMobileAlt size={80} color="var(--brand-primary)" />,
    title: "Mobile App Development (iOS & Android)",
    description: "Native and cross-platform mobile apps for iOS and Android, designed to engage your customers everywhere. We handle everything from UI/UX to deployment, ensuring your app stands out in the marketplace.",
  },
  {
    icon: <FaBuilding size={80} color="var(--brand-primary)" />,
    title: "Enterprise Software Solutions",
    description: "Robust, scalable enterprise systems to streamline operations and drive growth. Our solutions integrate seamlessly with your existing infrastructure and support your evolving business needs.",
  },
  {
    icon: <FaCloud size={80} color="var(--brand-primary)" />,
    title: "Cloud-Based Applications",
    description: "Modern cloud-native apps for flexibility, scalability, and cost efficiency. We help you leverage the power of the cloud for secure, accessible, and always-on business solutions.",
  },
  {
    icon: <FaPlug size={80} color="var(--brand-primary)" />,
    title: "API Development & Integration",
    description: "Secure, reliable APIs and seamless integrations with third-party services. We enable your systems to communicate efficiently, unlocking new capabilities and business opportunities.",
  },
  {
    icon: <FaDatabase size={80} color="var(--brand-primary)" />,
    title: "Database Design & Optimization",
    description: "Efficient, secure database solutions for performance and reliability. We design, implement, and optimize databases to ensure your data is always available and protected.",
  },
  {
    icon: <FaCogs size={80} color="var(--brand-primary)" />,
    title: "Software Architecture & Design",
    description: "Expert architecture and design for scalable, maintainable software systems. We create blueprints that ensure your software is robust, flexible, and future-proof.",
  },
  {
    icon: <FaSyncAlt size={80} color="var(--brand-primary)" />,
    title: "Legacy System Modernization",
    description: "Upgrade and modernize your legacy systems for today's business challenges. We help you transition smoothly to modern platforms while minimizing risk and downtime.",
  },
];

const SoftwareDevelopment = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Software Development Consultation - Syrol Tech</title>
        <meta name="description" content="Expert software development consultation services. Get tailored solutions for web, mobile, and enterprise applications." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Software Development Consultation"
        pageName="Software Development"
        breadcrumbsImg={bannerbg}
      />
      {/* Hero Section - Modern, full-width with background image and overlay */}
      <section className="consultation-hero-section position-relative w-100" style={{minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat`}}>
        <div className="hero-overlay" style={{position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1}}></div>
        <div className="container position-relative" style={{zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left'}}>
          <h1 style={{color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem'}}>Leverage the power of expert software development consultation</h1>
          <p style={{color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem'}}>For tailored strategies, actionable insights, and technology guidance that drive your business forward. Get clarity, avoid costly mistakes, and accelerate your digital success.</p>
          <Link to="/consultation" className="readon orange-btn" style={{padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s'}}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Software Development Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default SoftwareDevelopment; 